import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 预览 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 下载 ")

import { withDefaults } from "vue";
import { downloadTableFile } from "@/utils/download";
import { getFileType } from "@/utils/type";


export default /*#__PURE__*/_defineComponent({
  props: {
    tableData: { default: () => [] }
  },
  setup(__props: any) {



const COLUMNS = [
  {
    title: "文件名称",
    slots: { customRender: "FileName" },
    width: 880,
  },
  {
    title: "操作",
    width: 150,
    slots: { customRender: "actionBtn" },
  },
];

const handlePreview = (path: string) => {
  const type = getFileType(path);
  if (type == 3 || type == 6 || type == 7) {
    window.open(`https://view.officeapps.live.com/op/view.aspx?src=${path}`);
  } else {
    window.open(path);
  }
};
const download = async (filename: string, Id: number | string) => {
  downloadTableFile(filename, Id as string);
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createBlock(_component_a_table, {
    class: "detail-table",
    rowClassName: "sign-table-tr",
    pagination: false,
    dataSource: __props.tableData,
    columns: COLUMNS
  }, {
    FileName: _withCtx(({ text: record }) => [
      (record.AccessoryType == '1211' && record.FileUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, " 其他需协助的文件 "))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(record.AccessoryTypeName), 1))
    ]),
    actionBtn: _withCtx(({ text: record }) => [
      (record.FileUrl)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _withDirectives(_createVNode(_component_a_button, {
              type: "link",
              style: {"padding":"0"},
              onClick: ($event: any) => (handlePreview(record.FileUrl as string))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 2
            }, 1032, ["onClick"]), [
              [_vShow, !record.FileUrl.includes('.zip')]
            ]),
            _createVNode(_component_a_button, {
              type: "link",
              class: _normalizeClass([
            record.FileUrl.includes('.zip') ? 'preview-none' : 'preview-block',
          ]),
              style: {"padding-right":"0px","padding-bottom":"0","padding-top":"0"},
              onClick: ($event: any) => (
            download(record.FileName as string, record.Id as number)
          )
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1032, ["class", "onClick"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["dataSource"]))
}
}

})